<template>
    <b-modal id="admission_form" ref="admission_form"
             @hidden="resetForm" no-close-on-backdrop
             modal-class="modal-right modal-dialog-scrollable">

        <template v-slot:modal-title>
            {{ !edit ? 'Add New Admission' : 'Edit Admission' }}
        </template>

        <div class="d-flex flex-row mb-4">
            <span class="iconsminds-add mr-3 menu-icon-style"/>

            <p class="my-auto">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi
                dolores quod, repellendus similique sint.
            </p>
        </div>

        <b-form>

            <b-row v-if="validationError">
                <b-colxx md="12">
                    <b-alert class="text-center" show variant="danger"
                             v-text="validationError"/>
                </b-colxx>
            </b-row>

            <b-row v-if="client">
                <b-colxx md="12" class="mb-1">
                    <b-alert show variant="info">
                        Facility: {{ client.data.attributes.facility }}
                    </b-alert>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Client" class="has-float-label">
                        <template v-slot:label>
                            <span>Client <sup><code>*</code></sup></span>
                        </template>

                        <v-select label="client_id" :filterable="false" v-model="selected.client" :options="clients"
                                  @search="fetchClients" @input="updateClient" :border-danger="'client_id' in errors"
                                  :disabled="edit">
                            <template slot="no-options">
                                type to search client...
                            </template>

                            <template slot="option" slot-scope="option">
                                <div class="d-center">
                                    <div class="d-flex flex-row">
                                        <img class="mr-2" :src="clientImage(option)" :alt="option.data.name"
                                             style="height: 25px; width: 25px; object-fit: cover"/>
                                        <p class="my-auto">
                                            {{ option.data.attributes.name + " (SSN: " + option.data.attributes.ssn + ")" }}</p>
                                    </div>
                                </div>
                            </template>

                            <template slot="selected-option" slot-scope="option">
                                <div class="selected d-center">
                                    <div class="d-flex flex-row">
                                        <img class="mr-2" :src="clientImage(option)" :alt="option.data.name"
                                             style="height: 16px; width: 16px; object-fit: cover"/>
                                        <span
                                            class="my-auto">{{ option.data.attributes.name + " (SSN: " + option.data.attributes.ssn + ")" }}</span>
                                    </div>
                                </div>
                            </template>

                            <template slot="spinner" slot-scope="spinner">
                                <div class="spinner-border text-primary" v-show="spinner"></div>
                            </template>
                        </v-select>

                        <b-form-invalid-feedback :state="!('client_id' in errors)"
                                                 v-text="'client_id' in errors ? errors.client_id[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Unit" class="has-float-label">
                        <template v-slot:label>
                            <span>Unit <sup><code>*</code></sup></span>
                        </template>
                        <v-select v-if="!units"/>
                        <v-select v-else @input="updateUnit" v-model="selected.unit" :options="units"
                                  :border-danger="'unit_id' in errors" :disabled="edit"/>
                        <b-form-invalid-feedback :state="!('unit_id' in errors)"
                                                 v-text="'unit_id' in errors ? errors.unit_id[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Moved-in" class="has-float-label">
                        <template v-slot:label>
                            <span>Moved-in <sup><code>*</code></sup></span>
                        </template>

                        <v-date-picker
                            popover-visibility="focus" mode="single"
                            v-model="datepicker.move_in"
                            @input="'move_in' in errors ? delete errors.move_in : ''"
                            :input-props="{ class:'form-control' + ('move_in' in errors ? ' border-danger' : ''), placeholder: 'MM-DD-YYYY' }"/>
                        <b-form-invalid-feedback :state="!'move_in' in errors"
                                                 v-text="'move_in' in errors ? errors.move_in[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12" class="mb-4">
                    <b-form-group label="Remarks" class="has-float-label">
                        <b-form-textarea v-model="form.remarks" rows="6" placeholder="Remarks"/>
                    </b-form-group>
                </b-colxx>
            </b-row>
        </b-form>

        <template slot="modal-footer">
            <b-button variant="outline-secondary" @click="hideModal('admission_form')" v-text="'Cancel'"/>

            <state-button v-if="!edit" variant="primary" :click="submitAdmission">Submit</state-button>

            <state-button v-else variant="primary" :click="updateAdmission">Update</state-button>
        </template>
    </b-modal>
</template>

<script>
import {mapGetters} from "vuex";
import moment from "moment";
import StateButton from "../../../../../components/Common/StateButton";

export default {

    name: "AdmissionFormModal",

    components: {
        StateButton
    },

    props: [
        'edit',
    ],

    data() {
        return {
            loading: true,
            clients: [],
            client: null,
            selected: {
                unit: [],
                client: [],
            },
            datepicker: {
                move_in: null,
            },
            validationError: null,
        }
    },

    computed: {
        ...mapGetters({
            form: 'getAdmissionForm',
            errors: 'getAdmissionErrors',
            facilities: 'getSelectFacilities',
            units: 'getSelectVacantUnits',
        }),
    },

    watch: {
        form() {
            if (this.edit) {
                this.selected.client = this.form.select_client;
                this.selected.facility = this.form.select_facility;
                this.selected.unit = this.form.select_unit;

                this.datepicker.move_in = moment(this.form.move_in).toDate();
            }
        },

        'datepicker.move_in'(date) {
            if (moment(date).format('YYYY-MM-DD') === 'Invalid date') return this.form.move_in = null;
            this.form.move_in = moment(date).format('YYYY-MM-DD');
        },

    },

    mounted() {
        this.getFormData();
    },

    methods: {

        async getFormData() {
            await this.$store.dispatch('fetchSelectFacilities');

            return this.loading = false;
        },

        fetchClients: _.debounce(function (search, loading) {
            if (search) {
                axios.get(`/api/hms/search/admissions/clients?search=${escape(search)}`)
                    .then(response => {
                        this.clients = response.data.data;
                        loading(false)
                    })
            }
        }, 300),

        updateClient(field) {
            this.client = field;
            if (field) {
                this.form.client_id = field.client_id;
                this.form.facility_id = field.data.attributes.facility_id;
                this.$store.dispatch('fetchSelectVacantUnits', field.data.attributes.facility_id);
            } else {
                this.form.client_id = '';
            }

            'client_id' in this.errors ? delete this.errors.client_id : '';
        },

        clientImage(client) {
            if (client.data.attributes.image !== 'Not Assigned') {
                return '/storage/images/clients/' + client.data.attributes.image;
            }

            if ((client.data.attributes.gender).toLowerCase() === 'male') {
                return '/default/gender_male.png';
            } else if ((client.data.attributes.gender).toLowerCase() === 'female') {
                return '/default/gender_female.png';
            } else {
                return '/default/gender_unknown.png';
            }
        },

        resetForm() {
            this.$store.commit('setAdmissionForm');

            this.validationError = null;

            this.selected = {
                unit: [],
                client: []
            };

            this.datepicker = {
                move_in: null,
            };

            this.client = null;
        },

        updateVendor(field) {
            if (field) {
                this.form.vendor_id = field.vendor_id;
            } else {
                this.form.vendor_id = '';
            }
            'vendor_id' in this.errors ? delete this.errors.vendor_id : '';
        },

        updateUnit(field) {
            if (field) {
                this.form.unit_id = field.unit_id;
            } else {
                this.form.unit_id = '';
            }
            'unit_id' in this.errors ? delete this.errors.unit_id : '';
        },

        hideModal(refname) {
            this.$refs[refname].hide();
        },

        submitAdmission() {
            return new Promise((success, fail) => {
                this.$store.dispatch('submitAdmission', this.form)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetForm();

                            this.$notify('success filled', 'Success!', 'Admitted new client!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('admission_form');
                        }, 2000);
                    })
                    .catch(error => {
                        this.validationError = error.response.data.error;

                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },

        updateAdmission() {
            return new Promise((success, fail) => {
                this.$store.dispatch('updateAdmission', this.form)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetForm();

                            this.$notify('success filled', 'Success!', 'Updated the admission!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('admission_form');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },
    }

}
</script>

<style scoped>

</style>
